import { styled } from '@mui/material/styles';

export const RangeContainer = styled('div')(
  ({ theme }) => `
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: center;
  position: relative;
  height: 32px;
  margin-bottom: 20px;

  .slider {
    position: relative;
    width: 100%;
  }

  .slider__track,
  .slider__range,
  .slider__left-value,
  .slider__right-value {
    position: absolute;
  }

  .slider__track,
  .slider__range {
    border-radius: 3px;
    height: 2px;
  }

  .slider__track {
    background-color: ${theme.palette.gray[400]};
    width: 100%;
    z-index: 1;
  }

  .slider__range {
    background-color: ${theme.palette.primary.main};
    z-index: 2;
  }

  .slider__left-value,
  .slider__right-value {
    color: ${theme.palette.gray[900]};
    background: ${theme.palette.white};
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    margin-top: 24px;
    padding: 3px 6px;
  }

  .slider__left-value {
    left: 0;
  }

  .slider__right-value {
    right: 0;
  }

  /* Removing the default appearance */
  .thumb,
  .thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }

  .thumb {
    pointer-events: none;
    position: absolute;
    height: 0;
    width: 100%;
    outline: none;
  }

  .thumb--zindex-3 {
    z-index: 3;
  }

  .thumb--zindex-4 {
    z-index: 4;
  }

  .thumb--zindex-5 {
    z-index: 5;
  }

  /* For Chrome browsers */
  .thumb::-webkit-slider-thumb {
    background-color: ${theme.palette.primary.main};
    border: none;
    border-radius: 50%;
    cursor: pointer;
    height: 18px;
    width: 18px;
    margin-top: 2px;
    pointer-events: all;
    position: relative;
  }

  /* For Firefox browsers */
  .thumb::-moz-range-thumb {
    background-color: ${theme.palette.primary.main};
    border: none;
    border-radius: 50%;
    cursor: pointer;
    height: 18px;
    width: 18px;
    margin-top: 2px;
    pointer-events: all;
    position: relative;
  }
`
);
